angular.module('tf.directives')

    .directive('disableOutsideScroll', [function(){
        return {
            restrict : 'A',
            link : function(scope, element, attrs){
                element.removeAttr('disable-outside-scroll');
                $(element).find('.templates-gallery').on('mousewheel DOMMouseScroll', function(e){
                    try {
                        var delta = e.originalEvent.wheelDelta || -e.originalEvent.detail;
                        this.scrollTop = (this.scrollTop + (delta < 0 ? 1 : -1) * 30);
                        e.stopPropagation();
                        e.preventDefault();
                    } catch (ex) {
                    }
                });
            }
        };
    }]);